const initialState = {
  showSideBar: false,
  sideBarComponent: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_SIDE_BAR':
      return {
        ...state,
        showSideBar: action.show
      }
    case 'HIDE_SIDE_BAR':
      return {
        ...state,
        showSideBar: false
      }
    case 'SHOW_SIDE_BAR':
      return {
        ...state,
        showSideBar: true
      }
    case 'SET_COMPONENT':
      return {
        ...state,
        sideBarComponent: action.component
      }
    default:
      return state
  }
}
